<div *ngIf="boxShow" class="fixed-box fixed left-0 bottom-0 full-width z-index-600 light-2" [ngClass]="[bgColor]" [@isShow]="boxShow">
  <div class="content-wrap full-height flex row wrap y-items-center">
    <div class="full-width">
      <div class="fixed-box-jackpot">
        <h3 class="flex row wrap y-items-center uppercase relative-left">
          <figure class="relative-left top--50p margin-right-10">
            <ng-container *ngIf="sys === 'wt'">
              <img
                *ngIf="('logoFlat' | translate)"
                [attr.src]="baseUrl + sys + '/flat/'+ prodId +'.png'"
                width="95"
                class="logo-flat"
                [attr.alt]="name"
              />
              <img
                *ngIf="product != 'raffles' && !('logoFlat' | translate)"
                [attr.src]="baseUrl + sys + '/' + prodId +'.png'"
                width="50"
                class="logo-normal"
                [attr.alt]="name"
              />
              <img
                *ngIf="product === 'raffles' && !('logoFlat' | translate)"
                [attr.src]="baseUrl + sys + '/r_' + prodId +'.png'"
                width="50"
                class="logo-normal"
                [attr.alt]="name"
              />
            </ng-container>
            <ng-container *ngIf="sys === 'ltk'">
              <img
                *ngIf="product != 'raffles' && product != 'syndicates'"
                [attr.src]="baseUrl + sys + '/' + prodId +'.png'"
                width="50"
                class="logo-normal"
                [attr.alt]="name"
              />
              <ng-container *ngIf="('lang' | translate) === 'en'">
                <img
                  *ngIf="product === 'syndicates'"
                  [attr.src]="baseUrl + sys + '/en/syn_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
                <img
                  *ngIf="product === 'raffles'"
                  [attr.src]="baseUrl + sys + '/en/r_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
              </ng-container>
              <ng-container *ngIf="('lang' | translate) === 'es'">
                <img
                  *ngIf="product === 'syndicates'"
                  [attr.src]="baseUrl + sys + '/es/syn_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
                <img
                  *ngIf="product === 'raffles'"
                  [attr.src]="baseUrl + sys + '/es/r_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
              </ng-container>
              <ng-container *ngIf="('lang' | translate) === 'pl'">
                <img
                  *ngIf="product === 'syndicates'"
                  [attr.src]="baseUrl + sys + '/pl/syn_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
                <img
                  *ngIf="product === 'raffles'"
                  [attr.src]="baseUrl + sys + '/pl/r_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
              </ng-container>
              <ng-container *ngIf="('lang' | translate) === 'pt'">
                <img
                  *ngIf="product === 'syndicates'"
                  [attr.src]="baseUrl + sys + '/pt/syn_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
                <img
                  *ngIf="product === 'raffles'"
                  [attr.src]="baseUrl + sys + '/pt/r_' + prodId +'.png'"
                  width="50"
                  class="logo-normal"
                  [attr.alt]="name"
                />
              </ng-container>
            </ng-container>
          </figure>
          <span class="fb-jackpot-wrap block relative-left txt-left">
            <span class="fb-jackpot">
              <strong>
                <small class="inline-block">
                  <ng-container *ngIf="currency == 'USD'">
                    us
                  </ng-container>
                  <ng-container *ngIf="currency == 'BRL'">
                    r
                  </ng-container>
                  <ng-container *ngIf="currency == 'AUD'">
                    $
                  </ng-container>
                  <ng-container *ngIf="currency == 'PLN'">
                    z
                  </ng-container> </small
                ><span class="inline-block margin-right-5">
                  <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL'">$</ng-container>
                  <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
                  <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
                  <ng-container *ngIf="currency == 'AUD'">A</ng-container>
                  <ng-container *ngIf="currency == 'PLN'">ł</ng-container></span
                >{{jackpot < 1 ? '' : jackpot}}<small class="jackpot-millions inline-block margin-left-5 uppercase">
                  <ng-container *ngIf="('lang' | translate) == 'en'">{{jackpot < 1 ? 'Pending' : "Million"}}</ng-container>
                  <ng-container *ngIf="('lang' | translate) == 'es'">{{jackpot < 1 ? 'Pendiente' : "Millones"}}</ng-container>
                  <ng-container *ngIf="('lang' | translate) == 'pt'">{{jackpot < 1 ? 'Pendente' :"MILHÕES"}}</ng-container>
                </small>
              </strong>
            </span>
            <span class="fb-name block"> {{name}}<span class="inline-block fb-country margin-left-5">{{country}}</span> </span>
          </span>
        </h3>
      </div>
      <div class="fixed-box-play relative-right">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="fixed-box-arrow-wrap absolute top--20 left-0 full-width">
    <div class="fixed-box-arrow absolute top-0 left-50p"></div>
  </div>
</div>
